import React from 'react'
import './AnalyticsPieChartLegend.less'
import IconFont, {
  SimpleLineIconsTypes
} from '../../../components/common/IconFont'

export interface IAnalyticsPieChartLegend {
  value: number
  color: string
  label: string
  icon: SimpleLineIconsTypes
  percentage: number
}

export interface IAnalyticsPieChartLegendProps {
  legendData: IAnalyticsPieChartLegend[]
}

const AnalyticsPieChartLegend = ({
  legendData
}: IAnalyticsPieChartLegendProps) => {
  return (
    <div className="AnalyticsPieChartLegend">
      {legendData.map((item, index) => {
        return (
          <div className="AnalyticsPieChartLegend__item" key={index}>
            <div
              className="AnalyticsPieChartLegend__color"
              style={{ backgroundColor: item.color }}
            />
            <div className="AnalyticsPieChartLegend__label">
              {item.icon && <IconFont type={item.icon} />}
              {item.label && item.label}
            </div>
            <div className="AnalyticsPieChartLegend__value">
              {item.percentage}%
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AnalyticsPieChartLegend
